const is_plain_object = (value) =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const as_object = (value) => (is_plain_object(value) ? { ...value } : {});

const get_value = (source, key) => {
  const source_object = as_object(source);
  const found_entry = Object.entries(source_object).find(([entry_key]) => entry_key === key);

  return Array.isArray(found_entry) ? found_entry[1] : undefined;
};

const as_string = (value, fallback = '') => (value == null ? fallback : String(value));

export const parse_api_data = (payload) =>
  as_object(typeof payload === 'string' ? JSON.parse(payload || '{}') : payload);

export const get_api_response_message = (response_data, fallback_message) => {
  const message = get_value(response_data, 'message');
  const data = get_value(response_data, 'data');

  return as_string(message || data, '') || fallback_message;
};

export const get_api_error_message = (error, fallback_message) => {
  const error_object = as_object(error);
  const response = as_object(get_value(error_object, 'response'));
  const response_data = parse_api_data(get_value(response, 'data'));
  const error_message = get_value(error_object, 'message');

  return get_api_response_message(response_data, as_string(error_message, '') || fallback_message);
};
